"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramdaAdjunct = require("ramda-adjunct");

var _camelcase = _interopRequireDefault(require("camelcase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var camelizeKeys = obj => {
  if (Array.isArray(obj)) {
    return obj.map(v => camelizeKeys(v));
  }

  if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => _objectSpread(_objectSpread({}, result), {}, {
      // eslint-disable-next-line no-unused-vars
      [(0, _camelcase.default)(key)]: camelizeKeys(obj[key])
    }), {});
  }

  return obj;
};

var _default = input => {
  if ((0, _ramdaAdjunct.isNilOrEmpty)(input)) {
    return input;
  }

  if ((0, _ramdaAdjunct.isString)(input) || (0, _ramdaAdjunct.isArray)(input)) {
    return (0, _camelcase.default)(input);
  }

  if ((0, _ramdaAdjunct.isObj)(input)) {
    return camelizeKeys(input);
  }

  return input;
};

exports.default = _default;